import { defineComponent as _defineComponent } from 'vue'
import { VIcon } from 'vuetify/lib';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'icon-text',
  props: {
    icon: null,
    iconColor: null,
    text: null
  },
  setup(__props: any) {

	

return { __sfc: true,VIcon }
}

})